import { useEffect, useState, useRef } from 'react';

import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import EventRegistrationSidebar from 'hb-react/shared/apps/Events/components/EventRegistrationSidebar';
import Layout from 'hb-react/shared/apps/Events/components/Layout/';
import { useRegistrationFlowContext } from 'hb-react/shared/apps/Events/contexts/RegistrationFlowContext';
import UpdateInformationModal from 'hb-react/shared/components/User/UpdateInformationModal';
import { useUserDataSubscriber } from 'hb-react/shared/components/User/UpdateInformationModal/hooks/useUserDataSubscriber';

const SuccessWithUpdateUserModal = ({ children, event }) => {
  const { currentUser } = useDefaultAppContexts();
  const [openModal, setOpenModal] = useState(false);
  const hasOpenedModal = useRef(false);

  const { valuesStep2, valuesStep3 } = useRegistrationFlowContext();
  const { isModified, changeSet } = useUserDataSubscriber({
    user: currentUser,
    formState: {
      ...valuesStep3?.receipt,
      mobile_perso:
        valuesStep2?.network_events_booking?.attendees_attributes.find(
          ({ user_id: userId }) => userId === currentUser?.id,
        )?.mobile_phone,
    },
  });

  const onClose = () => {
    hasOpenedModal.current = true;
    setOpenModal(false);
  };

  useEffect(() => {
    if (isModified) {
      setOpenModal(true);
    }
  }, [isModified]);

  if (isModified && !hasOpenedModal.current) {
    return (
      <Layout
        sidebar={
          event && <EventRegistrationSidebar event={event} withShoppingCard />
        }
      >
        {openModal ? (
          <UpdateInformationModal
            isOpen
            changeSet={changeSet}
            onSuccess={onClose}
            onClose={onClose}
          />
        ) : null}
      </Layout>
    );
  }

  return children;
};

export default SuccessWithUpdateUserModal;
